import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Loading from '../Loading';
import {
  StyledBoxSend,
  StyledBoxText,
  StyledBoxLeyend,
  StyledInputMail,
  StyledInputSubmit
} from './style';

class ShareSend extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
      textareaValue: '',
      inputError: false,
      textareaError: false,
      clearError: true
    };
  }

  onClickBtnHandler = () => {
    const { onSend, error } = this.props;
    const { inputValue, textareaValue } = this.state;
    const emailList = inputValue.split(',');
    const emailListFormatted = emailList.map(item => item.trim());
    const inputErrorUpdated = !inputValue;
    const textareaErrorUpdated = !textareaValue;

    this.setState({
      inputError: inputErrorUpdated,
      textareaError: textareaErrorUpdated,
      clearError: false
    });
    this.getErrors(error, inputValue);
    if (!inputErrorUpdated && !textareaErrorUpdated) {
      onSend(emailListFormatted, textareaValue);
    }
  };

  onChangeInputEmailHandler = value => {
    this.setState({ inputValue: value, inputError: false, clearError: true });
  };

  onChangeTextareaMsgHandler = value =>
    this.setState({ textareaValue: value, textareaError: false });

  getErrors = (error, inputValue) => {
    const { inputError, clearError } = this.state;

    let msjError = '';

    if (error && !clearError) {
      if (inputValue.split(',').length > 1) {
        msjError = 'Al menos uno de los emails no es válido';
      } else {
        msjError = 'Email no válido';
      }
    }

    if (inputError) {
      msjError = 'Todos los campos son obligatorios';
    }

    return msjError;
  };

  render() {
    const { inputValue, textareaValue, textareaError } = this.state;
    const { isLoading, darkTitle, error } = this.props;
    const loadingColor = darkTitle ? 'dark' : 'light';

    return (
      <React.Fragment>
        {isLoading ? (
          <Loading color={loadingColor} txt="enviando" />
        ) : (
          <StyledBoxSend>
            <StyledBoxText darkTitle={darkTitle}>
              Enviar por e-mail
              <StyledBoxLeyend darkTitle={darkTitle}>
                Recuerda que sólo se admiten emails corporativos
              </StyledBoxLeyend>
            </StyledBoxText>
            <StyledInputMail
              type="text"
              placeholder="Añade emails, separados por comas"
              value={inputValue}
              onChange={this.onChangeInputEmailHandler}
              error={this.getErrors(error, inputValue)}
            />
            <StyledInputMail
              area
              multiline
              placeholder="Mensaje..."
              value={textareaValue}
              onChange={this.onChangeTextareaMsgHandler}
              error={textareaError}
            />
            <StyledInputSubmit onClick={this.onClickBtnHandler}>
              Enviar
            </StyledInputSubmit>
          </StyledBoxSend>
        )}
      </React.Fragment>
    );
  }
}

ShareSend.propTypes = {
  onSend: PropTypes.func,
  isLoading: PropTypes.bool,
  darkTitle: PropTypes.bool
};

export default ShareSend;
